<script>
import CustomerAutocomplete from '@/components/CustomerAutocomplete.vue'

export default {
  name: 'CustomerMergePage',
  components: {
    CustomerAutocomplete,
  },
  data() {
    return {
      form: {
        customer: '',
        oldCustomer: '',
        user: null,
      },
      customer: null,
      oldCustomer: null,
      isLoading: false,
      errors: {},
    }
  },
  computed: {
    userChoiceAlert() {
      return (
        Boolean(this.customer?.fufuUser && this.oldCustomer?.fufuUser) &&
        !this.form.user
      )
    },
    hasError() {
      return Object.keys(this.errors).length > 0
    },
    customerFields() {
      return [
        {
          text: this.$t('customerMerge.detail.text.customerCode'),
          key: 'account',
        },
        {
          text: this.$t('customerMerge.detail.text.registeredShop'),
          key: 'shopName',
        },
        {
          text: this.$t('customerMerge.detail.text.familyName'),
          key: 'familyName',
        },
        {
          text: this.$t('customerMerge.detail.text.givenName'),
          key: 'givenName',
        },
        ...(this.$i18n.locale === 'ja'
          ? [
              {
                text: this.$t('customerMerge.detail.text.familyNameKana'),
                key: 'familyNameKana',
              },
              {
                text: this.$t('customerMerge.detail.text.givenNameKana'),
                key: 'givenNameKana',
              },
            ]
          : []),
        {
          text: this.$t('customerMerge.detail.text.email'),
          key: 'email',
        },
        {
          text: this.$t('customerMerge.detail.text.phoneNumber'),
          key: 'phoneNumber',
        },
        {
          text: this.$t('customerMerge.detail.text.gender'),
          key: 'gender',
        },
        {
          text: this.$t('customerMerge.detail.text.birthday'),
          key: 'birthday',
        },
        {
          text: this.$t('customerMerge.detail.text.address'),
          key: this.getAddress,
        },
        {
          text: this.$t('customerMerge.detail.text.starterPassExpiryDate'),
          key: 'starterPassTo',
        },
        {
          text: this.$t('customerMerge.detail.text.note'),
          key: 'note',
        },
        {
          text: this.$t('customerMerge.detail.text.operationNote'),
          key: 'operationNote',
        },
        {
          text: this.$t('customerMerge.detail.text.visitCount'),
          key: 'aggregation.visitCount',
        },
        {
          text: this.$t('customerMerge.detail.text.counselingSheetWritten'),
          key: this.isCounselingSheetWritten,
        },
        {
          text: this.$t('customerMerge.detail.text.createdDateTime'),
          key: 'createdAt',
        },
        {
          text: this.$t('customerMerge.detail.text.updatedDateTime'),
          key: 'updatedAt',
        },
      ]
    },
    userFields() {
      return [
        {
          text: this.$t('customerMerge.detail.text.email'),
          key: 'email',
        },
        {
          text: this.$t('customerMerge.detail.text.phoneNumber'),
          key: 'phoneNumber',
        },
        {
          text: this.$t('customerMerge.detail.text.familyName'),
          key: 'familyName',
        },
        {
          text: this.$t('customerMerge.detail.text.givenName'),
          key: 'givenName',
        },
        {
          text: this.$t('customerMerge.detail.text.familyNameKana'),
          key: 'familyNameKana',
        },
        {
          text: this.$t('customerMerge.detail.text.givenNameKana'),
          key: 'givenNameKana',
        },

        {
          text: this.$t('customerMerge.detail.text.createdDateTime'),
          key: 'createdAt',
        },
        {
          text: this.$t('customerMerge.detail.text.updatedDateTime'),
          key: 'updatedAt',
        },
      ]
    },
  },
  watch: {
    customer() {
      this.resetUser()
    },
    oldCustomer() {
      this.resetUser()
    },
  },
  methods: {
    resetUser() {
      const u = this.customer?.fufuUser
      const old = this.oldCustomer?.fufuUser
      if (u && old) {
        this.form.user = null
      } else if (u) {
        this.form.user = u
      } else if (old) {
        this.form.user = old
      } else {
        this.form.user = null
      }
    },
    getValue(item, key) {
      if (typeof key === 'function') return key(item)
      let keys = key.split('.')
      let len = keys.length
      let obj = item
      for (let idx = 0; idx < len; ++idx) {
        if (!obj) return obj
        if (typeof obj !== 'object') return obj
        obj = obj[keys[idx]]
      }
      return obj
    },
    isCounselingSheetWritten(item) {
      if (!item) return
      return item.patchTest !== null
    },
    getAddress(cus) {
      if (!cus) return
      return `${cus.postcode} ${cus.prefecture}${cus.city}${cus.address}${cus.building}`
    },
    swap() {
      const form = this.form
      const cusId = form.customer
      form.customer = form.oldCustomer
      form.oldCustomer = cusId
      const cus = this.customer
      this.customer = this.oldCustomer
      this.oldCustomer = cus
    },

    async submit() {
      const cus = this.customer
      const old = this.oldCustomer
      if (
        !confirm(
          String(
            this.$t('customer.merge.message.confirmMerge', {
              oldAccount: old.account,
              newAccount: cus.account,
            })
          )
        )
      )
        return
      try {
        this.errors = {}
        this.isLoading = true
        await this.$api.customers().merge(this.form)
        this.$toast.success(this.$t('customer.merge.message.mergeSuccess'))
        this.form.user = null
        this.form.customer = null
        this.form.oldCustomer = null
      } catch (err) {
        this.$toast.error(this.$t('customer.merge.message.mergeFailed'))
        this.errors = this.$getValidationErrors(err)
        console.error(err)
      }
      this.isLoading = false
    },
  },
}
</script>

<template>
  <v-card flat>
    <v-card-title>
      {{ $t('navigation.text.mergeCustomer') }}
    </v-card-title>
    <v-card-text>
      <CustomerAutocomplete
        v-model="form.customer"
        outlined
        :label="$t('customer.merge.text.keepCustomer')"
        clearable
        @customer="customer = $event"
      />
      <v-btn class="mb-4" @click="swap">
        <v-icon>
          mdi-swap-vertical-bold
        </v-icon>
      </v-btn>

      <CustomerAutocomplete
        v-model="form.oldCustomer"
        outlined
        :label="$t('customer.merge.text.removeCustomer')"
        clearable
        @customer="oldCustomer = $event"
      />
      <v-alert type="warning" prominent :value="userChoiceAlert">
        {{ $t('customer.merge.text.userChoiceAlert') }}
        <br />
        {{ $t('customer.merge.text.userChoiceInstruction') }}
      </v-alert>
    </v-card-text>
    <v-subheader>{{ $t('customer.merge.text.customerInfo') }}</v-subheader>
    <v-simple-table>
      <thead>
        <tr>
          <th />
          <th>{{ $t('customer.merge.text.keepSide') }}</th>
          <th>{{ $t('customer.merge.text.removeSide') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(field, idx) in customerFields" :key="idx">
          <th v-text="field.text" />
          <td v-text="getValue(customer, field.key)" />
          <td v-text="getValue(oldCustomer, field.key)" />
        </tr>
      </tbody>
    </v-simple-table>

    <v-subheader>{{ $t('customer.merge.text.appUser') }}</v-subheader>
    <v-simple-table>
      <thead>
        <tr>
          <th>{{ $t('customer.merge.text.appUserSelection') }}</th>
          <th>
            <v-checkbox
              v-if="customer && customer.fufuUser"
              v-model="form.user"
              :value="customer.fufuUser"
            />
          </th>
          <th>
            <v-checkbox
              v-if="oldCustomer && oldCustomer.fufuUser"
              v-model="form.user"
              :value="oldCustomer.fufuUser"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(field, idx) in userFields" :key="idx">
          <th v-text="field.text" />
          <td v-text="getValue(customer && customer.userdata, field.key)" />
          <td
            v-text="getValue(oldCustomer && oldCustomer.userdata, field.key)"
          />
        </tr>
      </tbody>
    </v-simple-table>

    <v-alert type="error" :value="hasError">
      <template v-for="(val, key) in errors">
        <p v-for="(e, idx) in val" :key="`${key}-${idx}`" class="mb-0">
          {{ e }}
        </p>
      </template>
    </v-alert>

    <v-card-actions>
      <v-spacer />
      <v-btn
        color="error"
        :disabled="userChoiceAlert"
        :loading="isLoading"
        @click="submit"
      >
        {{ $t('customer.merge.button.executeMerge') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
